var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDivision(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 41,
    viewBox: "0 0 36 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8094 22.1812L6.63202 29.6418C5.50369 30.094 4.14972 29.1896 3.69838 28.0593L2.11869 22.6334C1.66736 21.503 2.57005 20.1465 3.69838 19.6943L29.8757 12.2337C31.004 11.7815 32.3581 12.6859 32.8094 13.8163L34.389 19.2422C34.8403 20.5986 34.1634 21.9551 32.8094 22.1812Z",
    fill: "#ADB7DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4942 4.99915C20.3969 7.93818 18.5915 10.8772 15.6579 11.7815C12.7242 12.6859 9.79053 10.8772 8.88787 7.93819C7.9852 4.99916 9.79056 2.06012 12.7242 1.1558C15.6579 0.477564 18.5916 2.06011 19.4942 4.99915Z",
    fill: "#ADB7DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3946 32.807C28.2973 35.746 26.4919 38.685 23.5583 39.5894C20.6246 40.4937 17.6909 38.6851 16.7883 35.746C15.8856 32.807 17.691 29.8679 20.6246 28.9636C23.5583 28.2854 26.4919 29.8679 27.3946 32.807Z",
    fill: "#ADB7DD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivision);
export default __webpack_public_path__ + "static/media/division.f003f3642f3f7740cf271d49c1e8bbd6.svg";
export { ForwardRef as ReactComponent };